/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboGetadminmfaenforcedGetAdminMFAEnforcedItem
 */
export interface JumboGetadminmfaenforcedGetAdminMFAEnforcedItem {
    /**
     * 
     * @type {boolean}
     * @memberof JumboGetadminmfaenforcedGetAdminMFAEnforcedItem
     */
    isEnforced?: boolean;
    /**
     * 
     * @type {string}
     * @memberof JumboGetadminmfaenforcedGetAdminMFAEnforcedItem
     */
    updatedAt?: string;
}

/**
 * Check if a given object implements the JumboGetadminmfaenforcedGetAdminMFAEnforcedItem interface.
 */
export function instanceOfJumboGetadminmfaenforcedGetAdminMFAEnforcedItem(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboGetadminmfaenforcedGetAdminMFAEnforcedItemFromJSON(json: any): JumboGetadminmfaenforcedGetAdminMFAEnforcedItem {
    return JumboGetadminmfaenforcedGetAdminMFAEnforcedItemFromJSONTyped(json, false);
}

export function JumboGetadminmfaenforcedGetAdminMFAEnforcedItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboGetadminmfaenforcedGetAdminMFAEnforcedItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isEnforced': !exists(json, 'isEnforced') ? undefined : json['isEnforced'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
    };
}

export function JumboGetadminmfaenforcedGetAdminMFAEnforcedItemToJSON(value?: JumboGetadminmfaenforcedGetAdminMFAEnforcedItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isEnforced': value.isEnforced,
        'updatedAt': value.updatedAt,
    };
}

